/**
 * IMPORTANT NOTICE:
 *
 * This file is used exclusively in the Vue 2 project and is scheduled for future removal.
 * For the Vue 3 project, please use the updated file located at:
 * /vue3/src/services/Shared/Events/Events.js
 *
 * Common Reference File:
 * The file `/js/Common/EventsService.js` is shared between both Vue 2 and Vue 3 projects.
 * Any changes should first be made in this common file to ensure consistency across projects.
 *
 * Modifications in this file require updates in the following locations:
 * - Vue 2 Project: This file (current location)
 * - Vue 3 Project: /vue3/src/services/Shared/Events/Events.js
 * - Common File: /js/Common/EventsService.js
 *
 * Please ensure all necessary changes are made in the **common file first**
 * to maintain compatibility and avoid duplication of effort.
 *
 * NOTE: If this file is modified, corresponding updates must be made
 * in both the Vue 2 and Vue 3 versions as indicated above.
 *
 * For questions or clarifications, please reach out to **Leela** directly.
 */

import Vue from 'vue';
import {
  CallLogConsumerEvent,
  checkSessionValidity,
  checkVinValidity,
  consumerEventsModal,
  eventConstants,
  getOfferType,
  prepareConsumerEventForSpecials,
  updateSessionIdWithPin,
  getEventDrivenSessionCount,
  prepareEventModel,
} from '../../Common/EventsService';
import store from '../../../store/store.js';
import * as actionTypes from '../../../store/types.js';
export const eventBus = new Vue();
export class Events {
  static eventsConstants = eventConstants;

  static consumerEventModel = consumerEventsModal;

  static notifyEvent(eventValue) {
    // no logic written in this method
    //Dont Write Logic Here -> Contact Team if you need to write anything here
  }

  static specialsEvent(
    eventId,
    styleId = '',
    vin = '',
    OfferID = '',
    OfferType = '',
    modelNumber = '',
    emailAddress = '',
    stockNo = '',
    vehicleMake = ''
  ) {
    const arrLogConsumerEvent = prepareConsumerEventForSpecials(
      eventId,
      styleId,
      vin,
      OfferID,
      OfferType,
      modelNumber,
      emailAddress,
      stockNo,
      vehicleMake
    );
    this.logConsumerEvent(arrLogConsumerEvent);
  }

  static async logConsumerEvent(eventData, setTimer = false) {
    //In showroom page on opening transact create new session amd pass to consumer events

    const consumerEventLogResponse = await CallLogConsumerEvent(eventData, setTimer);

    let eventModel = prepareEventModel(eventData);
    this.setEventSessionInStore(eventModel);
    return consumerEventLogResponse;
  }

  static updateSessionIdWithPin(sessionId) {
    return updateSessionIdWithPin(sessionId);
  }

  static checkSessionValidity(sessionId) {
    return checkSessionValidity(sessionId);
  }

  static checkVinValidity(vin) {
    return checkVinValidity(vin);
  }

  static getOfferType(eventId) {
    return getOfferType(eventId);
  }
  static setEventSessionInStore(eventModel) {
    let eventCount = getEventDrivenSessionCount(eventModel);
    store.commit(actionTypes.SET_EVENT_DRIVEN_SESSION_COUNT, eventCount);
  }
}
